import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { getTableColumnStyles, restrictedTableColumns } from "./tableLayout";

const borderColor = "#424949";
const styles = StyleSheet.create({
  row: {
    width: "100%",
    flexDirection: "row",
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "center",
    height: 14,
    fontStyle: "bold",
  },
  index: {
    height: "100%",
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    // paddingLeft: 1,
    fontSize: 7,
  },
  fulldate: {
    height: "100%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
    paddingLeft: 2,
    fontSize: 7,
  },
  fullHour: {
    height: "100%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
    paddingLeft: 2,
    fontSize: 7,
  },
  fullname: {
    height: "100%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
    paddingLeft: 2,
    fontSize: 7,
  },
  originHour: {
    height: "100%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
    paddingLeft: 2,
    fontSize: 7,
  },
  origin: {
    height: "100%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
    paddingLeft: 2,
    fontSize: 7,
  },
  destination: {
    height: "100%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
    paddingLeft: 2,
    fontSize: 7,
  },
  toll: {
    height: "100%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 4,
    fontSize: 8,
  },
  price: {
    height: "100%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 6,
    fontSize: 8,
  },
  originHourContainer: {
    maxHeight: 100, // Define la altura máxima que deseas
    overflow: "hidden", // Oculta el contenido que exceda la altura máxima
  },
  restrictedRow: {
    height: "auto",
    minHeight: 24,
    alignItems: "stretch",
  },
  restrictedCell: {
    fontSize: 10,
    lineHeight: 1.35,
    textAlign: "left",
    padding: 4,
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
});

const TableRow = ({ items, canViewTotal = false }) => {
  const columnStyles = getTableColumnStyles(canViewTotal);
  const Br = () => "\n";
  const rows = items.map((item) => {
    if (!canViewTotal) {
      return (
        <View
          style={[styles.row, styles.restrictedRow]}
          key={item.order_number.toString()}
          wrap={false}
        >
          {restrictedTableColumns.map(({ key, field }, index) => (
            <Text
              key={key}
              style={[
                styles.restrictedCell,
                columnStyles[key],
                key === "index" && { textAlign: "center" },
                index === restrictedTableColumns.length - 1 && { borderRightWidth: 0 },
              ]}
            >
              {item[field] ?? ""}
            </Text>
          ))}
        </View>
      );
    }

    return item.booking_type_id != 3 ? (
      <View style={styles.row} key={item.order_number.toString()}>
        <Text style={[styles.index, columnStyles.index]}>
          {item.order_number}
        </Text>
        <Text style={[styles.fullname, columnStyles.fullname]}>
          {item.fullname_employee}
        </Text>
        <Text style={[styles.fulldate, columnStyles.fulldate]}>{item.date}</Text>
        <Text style={[styles.origin, columnStyles.origin]}>{item.origin_name}</Text>
        <Text
          style={[styles.destination, columnStyles.destination]}
        >
          {item.destination_name}
        </Text>
        <Text style={[styles.toll, columnStyles.toll]}>{item.toll}</Text>
        {canViewTotal && (
          <Text style={[styles.price, columnStyles.price]}>{item.price_total}</Text>
        )}
      </View>
    ) : (
      <View
        style={{ ...styles.row, maxHeight: 44, height: "100%" }}
        key={item.order_number.toString()}
      >
        <Text style={[styles.index, columnStyles.index]}>
          {item.order_number}
        </Text>
        <Text style={[styles.fullname, columnStyles.fullname]}>
          {item.fullname_employee}
        </Text>
        <Text style={[styles.fullHour, columnStyles.fullHour]}>
          {item.date} {item.time}
          <Br />
          {item.dateEnd} {item.timeEnd}
        </Text>
        <Text style={[styles.originHour, columnStyles.originHour]}>
          ORIGEN: {item.origin_name}
          <Br />
          {item.notes.substring(0, 120)}
          <Br />
          DESTINO: {item.destination_name}
        </Text>

        <Text style={[styles.toll, columnStyles.toll]}>{item.toll}</Text>
        {canViewTotal && (
          <Text style={[styles.price, columnStyles.price]}>{item.price_total}</Text>
        )}
      </View>
    );
  });
  return <Fragment>{rows}</Fragment>;
};

export default TableRow;
